<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom: 0;">
      <!-- 搜索表单 -->
      <el-form :model="where" class="ele-form-search ele-table-tool-default" @keyup.enter.native="searchData()" @submit.native.prevent>
        <el-row :gutter="10" style="margin-top: 8px">
          <el-col :lg="7" :md="16" :sm="16" :xs="12">
            <el-form-item label="日期选择:">
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="medium"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                :unlink-panels="true"
            /></el-form-item>
          </el-col>
          <el-col :lg="16" :md="8" :sm="8" :xs="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="searchData" size="small" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="analysis-chart-card-sms">
        <ele-chart ref="schoolAllecharts" :option="option" style="height: 700px" />
      </div>
    </el-card>
  </div>
</template>

<script>
  import { compositeChart } from '@/config/api';
  import EleChart from '@/components/EleChart';
  export default {
    name: 'Index',
    components: { EleChart },
    data() {
      return {
        date: null,
        aa: null,
        chartData: {},
        where: {
          startTime: null,
          endTime: null,
        },
      };
    },
    computed: {
      option() {
        return {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
            },
          },
          legend: {
            data: ['学生数量', '宿舍学生数量', '班级学生行为评价总分', '宿舍量化总分', '班级量化总分'],
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          dataZoom: [
            {
              type: 'slider',
              show: true,
              yAxisIndex: [0],
              left: '0%',
              start: 100,
              end: 90,
            },
            {
              type: 'inside',
              yAxisIndex: [0],
              start: 100,
              end: 90,
            },
          ],
          xAxis: [
            {
              type: 'value',
            },
          ],
          yAxis: [
            {
              type: 'category',
              axisTick: {
                show: false,
              },
              data: this.chartData.classNameList,
            },
          ],
          series: [
            {
              name: '学生数量',
              type: 'bar',
              label: {
                show: true,
                position: 'inside',
              },
              emphasis: {
                focus: 'series',
              },
              data: this.chartData.studentNumList,
            },
            {
              name: '宿舍学生数量',
              type: 'bar',
              label: {
                show: true,
                position: 'inside',
              },
              emphasis: {
                focus: 'series',
              },
              data: this.chartData.studentNumsList,
            },
            {
              name: '班级学生行为评价总分',
              type: 'bar',
              label: {
                show: true,
                position: 'inside',
              },
              emphasis: {
                focus: 'series',
              },
              data: this.chartData.ptotalList,
            },
            {
              name: '宿舍量化总分',
              type: 'bar',
              label: {
                show: true,
                position: 'inside',
              },
              emphasis: {
                focus: 'series',
              },
              data: this.chartData.dtotalList,
            },
            {
              name: '班级量化总分',
              type: 'bar',
              label: {
                show: true,
                position: 'inside',
              },
              emphasis: {
                focus: 'series',
              },
              data: this.chartData.ctotalList,
            },
          ],
        };
      },
    },
    created() {
      this.setSelectTime();
      this.searchData();
    },
    methods: {
      // 查询
      searchData() {
        this.where = {
          startTime: this.date[0],
          endTime: this.date[1],
        };
        compositeChart(this.where).then((res) => {
          if (res.data.resCode == 200) {
            console.log(res.data.data);
            this.chartData = res.data.data;
          }
        });
      },
      // 默认本月日期
      setSelectTime() {
        let _this = this;
        let date = new Date();
        let y = date.getFullYear();
        let m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        let d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();

        let start_month = y + '-' + '01';
        let end_month = `${y}-${m}`;

        let start_day = y + '-' + m + '-' + '01';
        let end_day = `${y}-${m}-${d}`;

        _this.aa = [start_month, end_month]; //默认月份区间
        _this.date = [start_day, end_day]; //默认日期区间  页面显示的
        this.where.startTime = start_day; // 传入后台的 开始时间
        this.where.endTime = end_day; // 传入后台的 结束时间
      },
    },
  };
</script>

<style scoped>
  .analysis-chart-card-sms {
    height: 700px;
    box-sizing: border-box;
    margin-bottom: 12px;
    margin-top: 30px;
  }
</style>
